import { Box, Typography } from '@material-ui/core';

function LandingFooter() {
  return (
    <Box
      style={{
        display: 'flex',
        flex: 1,
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Box style={{ margin: 30 }}>
        <Typography component="span" style={{ fontSize: 18, color: '#999' }}>
          Jadwal.io
        </Typography>
      </Box>
    </Box>
  );
}

export default LandingFooter;
